import {gsap, ScrollTrigger} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";
export default class BlockBanner {
	static init() {

		GlobalVariables.resizeCallbacks.push(this);

		this.banner = document.querySelector('.banner');
		if( !this.banner ){
			return;
		}
		this.swiper = this.banner.querySelector('.banner-gallery .swiper');
		if (this.swiper) {
			this.initSwiper();
		}

		if( this.banner.classList.contains('banner-media-background') ){
			this.initMediaBackground();
		}

		if( this.banner.classList.contains('banner-media-below') ){
			this.initMediaBelow();
		}

	}

	static initMediaBackground(){

		if( this.bannerAnimation ){
			ScrollTrigger.refresh();
			ScrollTrigger.getById("myScrollTrigger").kill();
			gsap.set( this.banner, {
				clipPath: "inset(-0.5% -0.5% -0.5% -0.5% round 10px)",
				width: window.innerWidth,
				height: window.innerHeight
			}, {clearProps:"all"});
		}

		if( window.innerWidth > 768 ) {
			let dataLayout = this.banner.querySelector('[data-layout]');
			let props = window.getComputedStyle(dataLayout);
			let padding = props.getPropertyValue("padding-left");

			let header = document.querySelector(".header-main");
			this.bannerClipEvent = false;

			this.bannerAnimation = gsap.to(this.banner, {
				clipPath: `inset(${header.offsetHeight}px ${padding} ${padding} ${padding} round 10px)`,
				overwrite: true,
				scrollTrigger: {
					trigger: this.banner,
					start: 'top top',
					end: window.innerHeight,
					pin: !ScrollTrigger.isTouch,
					scrub: true,
					id: "myScrollTrigger",
					onUpdate: (self) => {
						if( self.progress <= 0.4 ){
							this.bannerClipEvent = false;
						}else if (self.progress > 0.4 && !this.bannerClipEvent) {
							this.bannerClipEvent = true;
							const event = new Event("bannerClip");
							document.dispatchEvent(event);
						}else if (self.progress === 1) {
							const event = new Event("bannerClipEnding");
							document.dispatchEvent(event);
						}
					}
				}
			});

			if( this.banner.classList.contains('banner-cancel-next-margin') ){
				this.banner.parentNode.classList.add('banner-cancel-next-margin');
			}
		}
	}

	static initMediaBelow(){

		let bannerImage = this.banner.querySelector('.banner-image');

		if( this.bannerAnimation ){
			this.bannerAnimation.kill();
			this.bannerAnimation = null;
			gsap.set( bannerImage, {
				clipPath: "inset(0 0 0 0 round 10px)"
			});
		}

		if( window.innerWidth > 768 ) {
			let dataLayout = this.banner.querySelector('.banner-layout');
			let props = window.getComputedStyle(dataLayout);
			let padding = props.getPropertyValue("padding-left");

			let mediaLayout = this.banner.querySelector('.banner-media');
			let propsMedia = window.getComputedStyle(mediaLayout);
			let paddingMedia = propsMedia.getPropertyValue("padding-left");

			let newPadding = parseFloat(padding) - parseFloat(paddingMedia);

			this.bannerAnimation = gsap.fromTo(bannerImage, {
				clipPath: `inset(0px ${newPadding}px ${newPadding*2}px ${newPadding}px round 10px)`,
				overwrite: true
			},
			{
				clipPath: `inset(0px 0px ${newPadding}px 0px round 10px)`,
				scrollTrigger: {
					trigger: bannerImage,
					start: 'top center',
					end: 'bottom center',
					scrub: 1,
					overwrite: true
				}
			});

			if( this.banner.classList.contains('banner-cancel-next-margin') ){
				this.banner.parentNode.classList.add('banner-cancel-next-margin');
			}
		}
	}

	static initSwiper(){

		let options = {
			autoplay: {
				delay: 3000,
			},
			speed: 800,
			slidesPerView: "1",
			loop: true,
			allowTouchMove: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			}
		};

		new Swiper(this.swiper, options);

	}

	static resize(){

		if( this.banner.classList.contains('banner-media-background') ){
			this.initMediaBackground();
		}

		if( this.banner.classList.contains('banner-media-below') ){
			this.initMediaBelow();
		}

	}

}
